module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "boxed form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('h1', {
    staticClass: "cc-txt-center"
  }, [_vm._v("Sign In")]), _vm._v(" "), (_vm.fetchError) ? _c('div', {
    staticClass: "alert alert-error"
  }, [_vm._v("\n            " + _vm._s(_vm.fetchError) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.login.loginInput.$error
    }
  }, [_c('div', {
    staticClass: "form-ps"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.login.loginInput),
      expression: "login.loginInput",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "..."
    },
    domProps: {
      "value": (_vm.login.loginInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.loginInput = $event.target.value.trim()
      }, function($event) {
        _vm.$v.login.loginInput.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (!_vm.$v.login.loginInput.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                Name must have at least " + _vm._s(_vm.$v.login.loginInput.$params.minLength.min) + " letters.\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.login.loginInput.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                Field is required\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.login.loginPass.$error
    }
  }, [_c('div', {
    staticClass: "form-ps"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.login.loginPass),
      expression: "login.loginPass",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "..."
    },
    domProps: {
      "value": (_vm.login.loginPass)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.loginPass = $event.target.value.trim()
      }, function($event) {
        _vm.$v.login.loginPass.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (!_vm.$v.login.loginPass.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                Name must have at least " + _vm._s(_vm.$v.login.loginPass.$params.minLength.min) + " letters.\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.login.loginPass.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                Field is required\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "form-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.loginRemember),
      expression: "login.loginRemember"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.login.loginRemember) ? _vm._i(_vm.login.loginRemember, "1") > -1 : (_vm.login.loginRemember)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.login.loginRemember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.login.loginRemember = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.login.loginRemember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.login.loginRemember = $$c
        }
      }
    }
  }), _vm._v("\n                    Remember me\n                ")])])]), _vm._v(" "), _c('button', {
    ref: "submitButton",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign In")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "ion-ios-contact-outline"
  }), _vm._v(" Login")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "ion-ios-locked-outline"
  }), _vm._v(" Pass.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-984ac668!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/login-form.vue
// module id = 234
// module chunks = 0